import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './home.css';
import './utbildningar.css';
import FadeInSection from '../animation/fadein_onscroll';

import heroImage from '../assets/krogarna_image.webp';
import partnerLogo from '../assets/krogarna_logo.png';

function Utbildningar() {
  const { t } = useTranslation();

  useEffect(() => {
    const scriptId = 'hubspot-145511650-embed';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js-eu1.hsforms.net/forms/embed/145511650.js';
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="subpage-padding utbildningar-page" id="start">
      <div className="utbildningar-container">
        <FadeInSection>
          <div className="utbildningar-heading">
            <h1>{t('utbildningar.pageTitle')}</h1>
            <p className="utbildningar-lead">{t('utbildningar.partnersLead')}</p>
          </div>
          <div className="utbildningar-heroLayout">
            <div className="utbildningar-heroMedia" aria-label={t('utbildningar.aria.packageImageAlt')}>
              <img
                src={heroImage}
                alt={t('utbildningar.aria.packageImageAlt')}
                className="utbildningar-heroImage"
              />

              <div className="utbildningar-heroLogoWrap" aria-label={t('utbildningar.aria.partnerLogoAlt')}>
                <img
                  src={partnerLogo}
                  alt={t('utbildningar.aria.partnerLogoAlt')}
                  className="utbildningar-heroLogo"
                />
              </div>
            </div>

            <div className="utbildningar-heroCardColumn">
              <aside className="utbildningar-partnerBanner">
                <span className="utbildningar-partnerBannerBadge" aria-hidden="true">
                  10%
                </span>
                <p className="utbildningar-partnerBannerText">{t('utbildningar.partnerDiscountBanner')}</p>
              </aside>
              <div className="utbildningar-heroCard" aria-label={t('utbildningar.aria.partnerCard')}>
                <div className="utbildningar-heroCardInner">
                  <div className="utbildningar-heroKicker">{t('utbildningar.partnerName')}</div>
                  <h2 className="utbildningar-heroTitle">{t('utbildningar.partnerSubtitle')}</h2>

                  <div className="utbildningar-heroText">
                    <p>{t('utbildningar.paragraph1')}</p>
                    <p>{t('utbildningar.paragraph2')}</p>
                    <p>{t('utbildningar.paragraph3')}</p>
                    <p>
                      <a
                        href="https://krogarna.se/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="utbildningar-link"
                      >
                        {t('utbildningar.partnerReadMoreLink')}
                      </a>
                    </p>
                  </div>

                  <a href="#intresseanmalan" className="button-primary utbildningar-heroCta">
                    {t('utbildningar.package.cta')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div
            className="utbildningar-form-card"
            aria-label={t('utbildningar.aria.formSection')}
            id="intresseanmalan"
          >
            <h2>{t('utbildningar.form.title')}</h2>
            <p className="sub-label">{t('utbildningar.form.description')}</p>

            <div
              className="hs-form-frame"
              data-region="eu1"
              data-form-id="50cae895-55c2-45d2-a305-a665af2b1a16"
              data-portal-id="145511650"
            />
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default Utbildningar;

